<template>
  <div class="flex flex-col items-start gap-4">
    <h1 class="mb-4 -mt-10 text-2xl font-semibold text-gray-900">
      Photo(s) {{ type === 'INVOICE' ? 'Facture' : 'Devis' }} {{ type === 'INVOICE' ? 'FA-' : 'DV-' }}{{ doc_number }}
    </h1>
    <form
      :action="endpoint"
      method="post"
      class="dropzone flex-1 w-full"
      :id="id"
      :ref="el => (dropzoneElement = el)"
    ></form>
    <router-link
      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      :to="type === 'INVOICE' ? '/invoices' : '/quotes'"
    >
      Retourner vers liste de {{ type === 'INVOICE' ? 'factures' : 'devis' }}
    </router-link>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted } from 'vue'
import useApi from '@/hooks/useApi'

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  doc_number: [String, Number],
  type: String,
})

const api = useApi()

const dropzoneElement = ref(null)
const dropzone = ref(null)
const options = ref({})
const endpoint = `/api/files/upload`

onMounted(() => {
  if (typeof window === 'undefined') return
  options.value = {
    url: endpoint,
    method: 'post',
    withCredentials: true,
    paramName: 'file',
    maxFilesize: 5, // MB
    uploadMultiple: false,
    chunking: false,
    clickable: true,
    // createImageThumbnails: false,
    addRemoveLinks: true,
    autoProcessQueue: true,
    acceptedFiles: '.jpeg,.jpg,.png,.gif',
    // accept: function(file, done) {
    //   if (file.name == "justinbieber.jpg") {
    //     return done("Naha, you don't.");
    //   }
    //   return done();
    // },
    dictDefaultMessage: '+ Ajouter photo(s)',
    dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    dictFallbackText: 'Please use the fallback form below to upload your files like in the olden days.',
    dictFileTooBig: 'File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.',
    dictInvalidFileType: "You can't upload files of this type.",
    dictResponseError: 'Server responded with {{statusCode}} code.',
    dictCancelUpload: 'Annuler',
    dictCancelUploadConfirmation: 'Are you sure you want to cancel this upload?',
    dictRemoveFile: 'Effacer photo',
    dictMaxFilesExceeded: 'You can not upload any more files.',
  }
  dropzone.value = new window.Dropzone(`form#${props.id}`, options.value)
  dropzone.value.on('sending', function (file, xhr, formData) {
    formData.append('doc_number', props.doc_number)
    formData.append('type', props.type)
  })
  dropzone.value.on('removedfile', function (file) {
    api.files.remove({ file: file.name, doc_number: props.doc_number, type: props.type }).catch(() => {
      dropzone.value.emit('addedfile', file)
    })
  })

  api.files.list({ doc_number: props.doc_number, type: props.type }).then(({ data }) => {
    ;(data.list || []).forEach(url => {
      const name = url.split('?')[0].split('/').slice(-1)[0]
      const mockFile = { name: name, size: 1000 }
      dropzone.value.emit('addedfile', mockFile)
      dropzone.value.emit('thumbnail', mockFile, url)
    })
  })
})
</script>

<style scoped>
.dropzone {
  padding: 0;
  min-height: 0;
  border-radius: 5px;
  border: 1px dashed #666;
  border-width: 2px;
}
.dz-size {
  display: none;
}
</style>
